import { render, staticRenderFns } from "./ButtonPermission.vue?vue&type=template&id=150cd714&scoped=true&"
import script from "./ButtonPermission.vue?vue&type=script&lang=js&"
export * from "./ButtonPermission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150cd714",
  null
  
)

export default component.exports